module.exports = __webpack_public_path__ + "img/2024_individual.8bd93fe2.webp";